"use strict";

var _regeneratorRuntime = require("F:\\TypeScript\\zymplectic\\node_modules\\@babel\\runtime/regenerator");

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(getAllDerivatives);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var expressions_1 = require("./expressions");

var parser_1 = require("./parser");

function getAllDerivatives(output, gradOutput) {
  var dependencies, dependencyDerivatives, dependency, dependencyDerivative, derivatives, der;
  return _regeneratorRuntime.wrap(function getAllDerivatives$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return {
            expression: output,
            derivative: gradOutput
          };

        case 2:
          dependencies = output.getDependencies();
          dependencyDerivatives = output.getDependencyDerivatives();
          dependency = dependencies.next();
          dependencyDerivative = dependencyDerivatives.next();

        case 6:
          if (!(!dependency.done && !dependencyDerivative.done)) {
            _context.next = 19;
            break;
          }

          derivatives = getAllDerivatives(dependency.value, dependencyDerivative.value(gradOutput));
          der = derivatives.next();

        case 9:
          if (der.done) {
            _context.next = 15;
            break;
          }

          _context.next = 12;
          return der.value;

        case 12:
          der = derivatives.next();
          _context.next = 9;
          break;

        case 15:
          dependency = dependencies.next();
          dependencyDerivative = dependencyDerivatives.next();
          _context.next = 6;
          break;

        case 19:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

exports.getAllDerivatives = getAllDerivatives;

function getDerivativeForExpression(expression, derivatives) {
  var sum = null;
  var derivative = derivatives.next();

  while (!derivative.done) {
    if (derivative.value.expression === expression) {
      sum = sum ? new expressions_1.Add(sum, derivative.value.derivative) : derivative.value.derivative;
    }

    derivative = derivatives.next();
  }

  return sum ? sum : new expressions_1.Constant(0);
}

exports.getDerivativeForExpression = getDerivativeForExpression;

function getAllVariables(output) {
  var variables = {};
  traverseBreadthFirst(output, function (expr) {
    if (expr instanceof expressions_1.Variable) {
      variables[expr.name] = expr;
    }
  });
  return variables;
}

exports.getAllVariables = getAllVariables;

function compileExpression(expression) {
  var compiled = parser_1.expressionToNode(expression).compile();
  return function (context) {
    return compiled.evaluate(context.variableValues);
  };
}

exports.compileExpression = compileExpression;

function traverseBreadthFirst(expr, visit) {
  visit(expr);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = expr.getDependencies()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var dependency = _step.value;
      traverseBreadthFirst(dependency, visit);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

exports.traverseBreadthFirst = traverseBreadthFirst;

function traverseDepthFirst(expr, visit) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = expr.getDependencies()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var dependency = _step2.value;
      traverseDepthFirst(dependency, visit);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  visit(expr);
}

exports.traverseDepthFirst = traverseDepthFirst;